module.exports = __webpack_public_path__ + "img/everPay-symbol.f3784bf9.svg";